module.exports = "/_next/static/images/Hero-f8d528414abc93ef041998ff30ff56ae.webp";